export enum ConnectionKeys {
  PROJECT_BLOCKS = 'pf-project-blocks',
  EARNABLE_HOURS = 'pf-earnable-hours',
}

export enum QueryKeys {
  EARNABLE_HOURS = 'earnableHours',
  COMMODITIES = 'commodities',
}
